import { render, staticRenderFns } from "./MerchantStatistics.vue?vue&type=template&id=68b5e8aa&scoped=true"
import script from "./MerchantStatistics.vue?vue&type=script&lang=js"
export * from "./MerchantStatistics.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatistics.vue?vue&type=style&index=0&id=68b5e8aa&prod&lang=less&scoped=true"
import style1 from "./MerchantStatistics.vue?vue&type=style&index=1&id=68b5e8aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5e8aa",
  null
  
)

export default component.exports